module.exports = __webpack_public_path__ + "static/media/response-user.98c23e7b.svg";